module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"state":{"title":"Form State","body":{"full":"To set this Form’s state, please visit the Project {formAccessSettings}.","formAccessSettings":"Form Access settings"}},"action":{"delete":"Delete this Form"},"alert":{"delete":"The Form “{name}” was deleted."}}}')
  delete Component.options._Ctor
}
